<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button type="primary" @click="startCreate()" size="mini">申请使用/外带印章</el-button>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>

    <div class="list-title">
      <el-row>
        <el-col class="item-input" :span="8">
          <label style="width:40px;text-align:left;">搜索：</label>
          <el-input style="margin-left:40px;" v-model="filterKey" size="mini" placeholder="你可以搜索印章名/申请人"></el-input>
        </el-col>
      </el-row>
    </div>


    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="tabType">
        <el-radio-button label="0">使用申请记录</el-radio-button>
        <el-radio-button label="1">外带申请记录</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column label="印章名称">
        <template slot-scope="scope">
          {{scope.row.sealName}}
        </template>
      </el-table-column>
      <!-- <el-table-column label="类型" width="50px">
        <template slot-scope="scope">
          {{ scope.row.type==0?'使用':'外带' }}
        </template>
      </el-table-column> -->

      <el-table-column label="申请人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.flow.creator'></user-info>
        </template>
      </el-table-column>

      <!-- <div v-if="tabType=='0'"> -->
      <el-table-column v-if="tabType=='0'" prop="useTime" align="center" label="计划使用时间" width="100px"
        :key="Math.random()">
      </el-table-column>
      <el-table-column v-if="tabType=='0'" align="center" label="实际使用时间" width="130px" :key="Math.random()">
        <template slot-scope="scope">
          {{ scope.row.confirmUseTime ? scope.row.confirmUseTime:'/' }}
        </template>
      </el-table-column>
      <!-- </div> -->

      <!-- <div> -->
      <!-- <el-table-column v-if="tabType=='1'" prop="useTime" label="计划领取时间" width="90px" :key="Math.random()">
      </el-table-column> -->

      <el-table-column v-if="tabType=='1'" label="实际领取时间" width="130px" :key="Math.random()">
        <template slot-scope="scope">
          {{ scope.row.confirmUseTime ? scope.row.confirmUseTime:'/' }}
        </template>
      </el-table-column>

      <!-- <el-table-column v-if="tabType=='1'" prop="returnTime" label="计划归还时间" width="90px" :key="Math.random()">
      </el-table-column> -->

      <el-table-column v-if="tabType=='1'" label="实际归还时间" width="130px" :key="Math.random()">
        <template slot-scope="scope">
          {{ scope.row.confirmReturnTime ? scope.row.confirmReturnTime:'/' }}
        </template>
      </el-table-column>
      <!-- </div> -->


      <el-table-column label="审批状态" width="90px">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>

      <el-table-column label="详情" width="130px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="projectDetail(scope.row.flow.applyId, '0', scope.row.sealId)"
            plain>点击查看详情</el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">
          <!-- 取消审批 -->
          <!-- <el-button v-if="scope.row.flow.status=='进行中' && scope.row.flow.creator.id == userData.id" type="warning" plain size="mini" @click="cancelSealFlow(scope.row)">取消</el-button> -->

          <span v-if="(scope.row.flow.status == '进行中'||scope.row.flow.status == '已拒绝'||scope.row.flow.status == '已取消') && scope.row.flow.creator.id == userData.id">
            <el-tooltip class="item" effect="dark" content="修改该审批" placement="bottom">
              <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="getRouterLink(scope.row)"></i>
            </el-tooltip>
            <cancel-flow :flow="scope.row.flow" @getLists='getLists'></cancel-flow>
          </span>
          <!-- 使用、借出和归还 -->
          <div v-if="backRole('SM_4')">
            <el-button v-if="scope.row.flow.status=='审批通过' && scope.row.status==''" type="success" plain size="mini"
              @click="sealUse(scope.row)">{{ tabType=='0'?'确认使用':'确认借出' }}</el-button>
            <el-button v-if="scope.row.flow.status=='审批通过' && scope.row.status=='已借出'" type="success" plain size="mini"
              @click="sealBack(scope.row)">确认归还</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info :admin="admin"></project-info>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import CancelFlow from '@/components/CancelFlow'
  import projectInfo from '@/page/user/projectInfo'
  import approvalType from '@/Mixins/approvalType'

  import UserInfo from '@/components/UserInfo'
  import ApprovalStatus from '@/components/ApprovalStatus'
  import Role from '@/Mixins/role'
  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
      CancelFlow,
    },
    mixins: [approvalType, Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 是否可切换公司
        noSelectOrganization: false,
        // 当前印章保管员
        admin: "",

        organizationListData: [],
        depId: '',
        addMeetingRoomStatus: false,

        tabType: 0,
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        // filter
        filterKey: "",
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7") {
        this.noSelectOrganization = false
        // this.depId = 0
      }

      // 获取会议
      this.getLists()
    },
    methods: {
      // 编辑的链接生成
      getRouterLink(row) {
        this.$router.push({
          path: '/Seal/Create',
          query: {
            applyId: row.flow.applyId,
          }
        })
      },
      // 获取详情
      projectDetail(applyId, tableType, sealId) {
        ajax.get("/seal/detail/" + sealId, "", (res) => {
          this.admin = res.vo.admin
        })
        // console.log(row)
        let _projectTable = {
          status: true,
          applyId,
          tableType,
        }
        // this.admin = admin
        // console.log(row)
        this.$store.commit('set_projectTable', _projectTable)
      },
      // 印章归还
      sealBack(row) {
        ajax.post('/seal/confirm/back', {
          sealUseApprovalId: row.id
        }, (res) => {
          this.$message.success("该印章状态已标记归还")
          this.getLists()

        })
      },
      sealUse(row) {
        ajax.post('/seal/confirm/use', {
          sealUseApprovalId: row.id
        }, (res) => {
          this.$message.success("该印章状态已标记使用")
          this.getLists()
        })
      },
      startCreate() {
        this.$router.push("/Seal/Create")
      },
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]

            if (_item.sealName.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 ||
              _item.flow.creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        let _url = this.tabType == '0' ? '/seal/use/list' : '/seal/take/list'

        ajax.get(_url, {
          'depId': this.depId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'depId'() {
        this.getLists()
      },
      'tabType'() {
        this.getLists()
      },
      filterKey() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/seal/uselist.vue